<template>
  <v-container grid-list-md class="rss-card-container" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
      
        <div class="flex xs12 section-header">{{ displayTitle }}</div>

        <section class="card-list opacity-0 no-scrollbar lozad">
          <div class="card-content"
              v-for="(item, idx) in articles"
              :key="idx"
          >
            <v-card :class="['card rss-card item ma-2', className]" :elevation="2" :href="item.link" target="_blank" rel="noopener noreferrer">
                <v-img v-if="displayThumb == 'true'"
                  class="card-thumb"
                  :src=item.thumbnail
                />
                <v-card-text>
                    <v-flex text-xs-left class="card-title"
                      style="cursor: pointer"
                    >
                    <div class="card-title" v-html="truncateText(item.title, 100, '...')"></div>
                    <div class="card-description" v-html="truncateText(item.description, 125, '...')"></div>
                    </v-flex>
                </v-card-text>
            </v-card>
          </div>
        </section>
   </v-container>
</template>

<script>
import rssApi from '../services/RssService'
import lozad from 'lozad'

export default {
  name: 'RssCards',
  props: [
      'newsSource',
      'displayTitle',
      'displayThumb',
      'className'
      ],
  data () {
    return {
      feedName: '',
      articles: [],
      show: false,
      loading: false,
      noData: false
    }
  },
  methods: {
    fetchNewsData () {
      rssApi.fetchCollection(this.newsSource)
        .then(response => {
          // eslint-disable-next-line no-console
          console.log(response)
          if (Object.keys(response).length) {
            // this.articles = this.articles.concat(response)
            this.feedName = response.feed.title
            this.articles = response.items
            this.loading = false
            this.noData = false
          } else {
            this.noData = true
            this.loading = false
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    },
    loadImages () {
      const observer = lozad('.lozad', {
          rootMargin: '100px 0px', // like css margin
          // threshold: 0.1 // ratio of element convergence
          loaded: function(el) {
              // Custom implementation on a loaded element
              el.classList.add('loaded');
              // el.classList.remove('loading-blur');
          }
      });

      observer.observe();
    },
    truncateText (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      }
      else {
        return text
      }
    }
  },
  mounted () {
    this.fetchNewsData(),
    this.loadImages()
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 6
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  }
}

</script>

<style lang="scss" scoped>
    .rss-card {
        height: 125px;
        //max-height: 100px;
        //min-height: 100px;

      .card-title {
        font-weight: 700;
        font-size: 1.125rem;
        line-height: 1.25rem;
        color: rgba(0, 0, 0, 0.87);
      }
      .card-description {
        font-weight: 400;
        font-size: .75rem;
        line-height: .875rem;
        color: rgba(0, 0, 0, 0.6);
        padding-top: 4px;
      }
    }

    .card-with-image {
      height: 250px;
      //max-height: 250px;
      //min-height: 250px;

      .card-thumb {
        height: 150px;
        //min-height: 150px;
        max-height: 150px;
      }

      .v-card__text {
        padding: 8px;
      }

      .card-title {
        font-weight: 700;
        font-size: 1.125rem;
        line-height: 1.25rem;
        color: rgba(0, 0, 0, 0.87);
      }
      .card-description {
        font-weight: 400;
        font-size: .75rem;
        line-height: .875rem;
        color: rgba(0, 0, 0, 0.6);
        padding-top: 4px;
      }
    }

    .macrumors {
      .card-description {
        display:none;
      }
    }
</style>
